<template>
	<section>
		<template v-if="attribute">
	  		<p :style="{'margin-left': margin}"><span style="font-weight:bold;">{{ attribute.name }}:</span> <span v-if="codeData">{{ codeData.name }}</span></p>
		</template>
	</section>
</template>
<script>
import { CodeService } from "@/services/code.service";
import { AttributeService } from "@/services/attributes.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
export default {
	props: [ 'coding', 'code', 'index' ],
    data: () => ({
    	attribute: null,
    	codeData: null,
    }),
    computed: {
		margin() {
			return (this.code.index * 15) + 'px';
		}
    },
    methods: {
    	getAttribute() {
    		AttributeService.show(this.code.attribute_id).then(response => {
                this.attribute = JsonDenormalizer.denormalize(response);
    		});
    	},
    	getCode() {
    		let code_id = this.coding.selectedData[this.index];
    		if (code_id) {
	    		CodeService.show(this.coding.selectedData[this.index]).then(response => {
	                this.codeData = JsonDenormalizer.denormalize(response);
	    		});
    		}
    	},
    },
    mounted() {
    	this.getAttribute();
    	this.getCode();
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Order/OrderCodes.vue